import { TooltipItem } from '@/screens/profile/profile-screen.types.ts';

export const TooltipContent = ({ items }: { items: TooltipItem[] }) => (
	<div className="tooltip-content">
		{items.map((item, i) => (
			<div
				key={i}
				className="tooltip-item">
				<span>{item.label}</span>
				<span>{item.value}</span>
			</div>
		))}
	</div>
);
